<script>
import { useCredentialsStore } from '@/stores/credentials.js';

export default {
  name: 'ViewHeader',
  props: {
    title: String,
    subTitle: String,
  },
  data() {
    return {
      credStore: useCredentialsStore(),
    };
  },
};
</script>

<template>
  <div class="w-100 h-44 rounded-b-2xl px-7 bg-theme-primary text-theme-secondary">
    <div class="title flex justify-between mb-6 pt-9 text-lg font-semibold">
      {{ title }}
    </div>
    <div class="text-3xl font-bold">
      {{ subTitle }}
    </div>
  </div>
</template>

<style scoped>
</style>
